import { render, staticRenderFns } from "./LeaveTypesView.vue?vue&type=template&id=6b3b333b&"
import script from "./LeaveTypesView.vue?vue&type=script&lang=js&"
export * from "./LeaveTypesView.vue?vue&type=script&lang=js&"
import style0 from "./LeaveTypesView.vue?vue&type=style&index=0&id=6b3b333b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports